export default __webpack_public_path__ + "static/media/home-web-agency-img-05.41eec298.jpg";